export const sharedHeaderSignInButtonClassName =
  "inline-flex h-10 cursor-pointer items-center justify-center rounded-full border border-white/10 bg-white/5 px-4 text-sm font-medium text-white shadow-[0_16px_40px_rgba(0,0,0,0.22)] transition-all duration-200 hover:bg-white/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/30";

export const sharedModalPrimaryButtonClassName =
  "h-12 w-full rounded-full bg-white text-black shadow-[0_20px_44px_rgba(255,255,255,0.16)] transition-all duration-200 hover:bg-white/90";

export const sharedModalSecondaryButtonClassName =
  "h-12 w-full rounded-full border border-white/10 bg-white/5 text-white transition-all duration-200 hover:bg-white/10 hover:text-white";
